import React from "react";
import { getImageLink, getImageAltText } from "../../../utils/images";
import { decodeText } from "../../../utils/richText";

const Image = ({ imageNode, className, style }) => {
    return <img src={getImageLink(imageNode)} alt={decodeText(getImageAltText(imageNode))} className={className} style={style} />;
};

export default Image;
